<template>
    <div class="tyn-media tyn-size-lg tyn-circle" data-bs-toggle="popover" data-bs-placement="top" :data-bs-content="getDataBs(usuario)">
        <img :src="usuario.urlImgFoto" alt="" v-if="usuario.urlImgFoto" />
        <h4 v-else 
            class="tyn-media tyn-size-lg tyn-circle text-white fw-bold" 
            :style="'background:#' + intToRGB(hashCode(usuario.nmUsuario)) ">
            {{ usuario.nmUsuario.slice(0,2) }}
        </h4>
    </div>
</template>

<script>
    export default {
        name: 'CirculoUsuario',
        data: function () {
            return {

            }
        },
        props: {
            usuario: Object,
        },
        computed: {},
        methods: {
            hashCode(str) {
                var hash = 0;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                return hash;
            },
            intToRGB(i) {
                var c = (i & 0x00FFFFFF)
                    .toString(16)
                    .toUpperCase();
                return "00000".substring(0, 6 - c.length) + c;
            },
            getDataBs(item) {
                return ` <span class="mb-0">${item.nmUsuario}</span> `;
            },
            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });

                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    customClass: 'custom-popover'
                                    //placement: "right",
                                });
                            });
                    }
                });
            },
        },
        mounted: function () {
            this.montaPopover();
        },
        watch: {
            
        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    
</style>